import { DateTime } from 'luxon';

import {
  transformLuxonDateToTuiDate,
  transformTuiToLuxon,
} from '@common/utils/date-form-transform';
import { getBrowserLang } from '@common/utils/lang';

export const dateTimeWithUserTimezone = (): DateTime => {
  const timezone = sessionStorage.getItem('timezone') || 'utc';
  return DateTime.local({ zone: timezone });
};

export const formatIsoDateToTuiWithTimezone = (isoDatetime: string) => {
  const timezone = sessionStorage.getItem('timezone') || 'utc';

  return transformLuxonDateToTuiDate(DateTime.fromISO(isoDatetime).setZone(timezone), {});
};

export const formatISOWithTimezone = (value: string | null | undefined): string => {
  if (!value) return '';

  if (!value.endsWith('Z')) {
    if (value.endsWith('+00:00')) {
      value = value.replace('+00:00', 'Z');
    } else {
      value = value.concat('Z');
    }
  }

  const timezone = sessionStorage.getItem('timezone') || 'utc';
  const dt = DateTime.fromISO(value, { zone: 'utc' });

  if (!dt.isValid) return '';

  return dt.setZone(timezone).toFormat("yyyy-MM-dd'T'HH:mm:ss'Z'");
};

export const formatDefaultDateFromISO = (
  value: string | null | undefined,
  date: string | null | undefined = 'dd.MM.yyyy',
  time: string | null | undefined = 'HH:mm:ss',
) => {
  if (!value) return '-';

  // TODO: КОСТЫЛЬ. Временно. Потом убрать(когда поправит бекенд)
  if (!value.endsWith('Z')) {
    if (value.endsWith('+00:00')) {
      value = value.replace('+00:00', 'Z');
    } else {
      value = value.concat('Z');
    }
  }
  const timezone = sessionStorage.getItem('timezone') || 'utc';
  const dateTime = DateTime.fromISO(value, { zone: timezone });

  if (!dateTime.isValid) return '-';

  const format = `${date} ${time}`;

  return dateTime.toFormat(format);
};

export const dateNowForFilename = () => {
  return DateTime.local().toFormat('yyyy-MM-dd_HH-mm-ss');
};

export const formatDefaultDateFromSeconds = (
  value: number | null | undefined,
  date: string | null | undefined = 'dd.MM.yyyy',
  time: string | null | undefined = 'HH:mm:ss',
) => {
  if (!value) return '-';

  const timezone = sessionStorage.getItem('timezone') || 'utc';
  const dateTime = DateTime.fromSeconds(value, { zone: timezone });

  if (!dateTime.isValid) return '-';

  const format = `${date} ${time}`;

  return dateTime.toFormat(format);
};

export const formatDefaultDateFromTui = (
  periodDateStart: any[] | null,
  periodDateEnd: any[] | null,
  options: {
    date?: string | null;
    time?: string | null;
    startPlaceholder?: string;
    endPlaceholder?: string;
  } = {},
) => {
  const {
    date = 'dd.MM.yyyy',
    time = 'HH:mm:ss',
    startPlaceholder = 'Choose start date',
    endPlaceholder = 'Choose end date',
  } = options;

  const locale = getBrowserLang();
  const format = `${date}\u00A0${time}`;
  const startDate = periodDateStart?.[0]
    ? transformTuiToLuxon(periodDateStart[0], { time: periodDateStart[1] }).toFormat(format, {
        locale,
      })
    : startPlaceholder;

  const endDate = periodDateEnd?.[0]
    ? transformTuiToLuxon(periodDateEnd[0], { time: periodDateEnd[1] }).toFormat(format, { locale })
    : endPlaceholder;

  return `${startDate} - ${endDate}`;
};

export const formatDateToRelativeFromISO = (value: string | null | undefined) => {
  if (!value) return '-';

  // TODO: КОСТЫЛЬ. Временно. Потом убрать(когда поправит бекенд)
  if (!value.endsWith('Z')) {
    if (value.endsWith('+00:00')) {
      value = value.replace('+00:00', 'Z');
    } else {
      value = value.concat('Z');
    }
  }

  const timezone = sessionStorage.getItem('timezone') || 'utc';
  const dateTime = DateTime.fromISO(value, { zone: timezone });

  if (!dateTime.isValid) return '-';

  return dateTime.toRelative();
};
